/* ew-plakkolom — slim plakpunt voor de productpagina-kolommen (13 sep 2026).
   Dawn zet .product__column-sticky op top:30px. Een kolom die HOGER is dan het
   scherm pint daardoor meteen vast en houdt zijn onderkant onbereikbaar onder de
   vouw (gemeten: 6 gestapelde foto's, 1.821px, vast op 30px — de onderste foto's
   verschenen pas als de tekstkolom op was). Hier krijgt elke kolom
   top = min(30, viewport − kolomhoogte − 30): past hij niet, dan scrolt hij
   eerst volledig in beeld en pint pas op zijn onderkant. Onder 990px (mobiel,
   één kolom) wordt de override gewist en geldt gewoon Dawn. */
(function () {
  var RAND = 30, MIN_BREED = 990;

  function zet() {
    var kolommen = document.querySelectorAll('.product__column-sticky');
    for (var i = 0; i < kolommen.length; i++) {
      var el = kolommen[i];
      if (window.innerWidth < MIN_BREED) { el.style.top = ''; continue; }
      var top = Math.min(RAND, window.innerHeight - el.offsetHeight - RAND);
      el.style.top = top + 'px';
    }
  }

  var plan = null;
  function later() { clearTimeout(plan); plan = setTimeout(zet, 120); }

  window.addEventListener('resize', later);
  window.addEventListener('load', zet);
  /* foto's laden na DOMContentLoaded en veranderen de kolomhoogte */
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(later);
    var kolommen = document.querySelectorAll('.product__column-sticky');
    for (var i = 0; i < kolommen.length; i++) ro.observe(kolommen[i]);
  }
  zet();
})();
